export default __webpack_public_path__ + "static/media/black-diamond.c3f69c61.jpg";